module.exports = __webpack_public_path__ + "img/logo@2x.dabc5ecf.png";